import { useContext } from "react";
import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import CropUnitForm from "components/agro/cropUnits/CropUnitForm";
import { createCropUnit } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const CropUnitCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const cropUnit = {
    farmID: "",
    lotID: "",
    name: "",
    plantingDate: "",
    cropType: "",
    unitType: "",
    quantity: "",
    performedById: "",
    photoEvidence: "",
    status: "",
    description: "",
    companyID: me?.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        farmID,
        lotID,
        name,
        plantingDate,
        cropType,
        unitType,
        quantity,
        performedById,
        photoEvidence,
        status,
        description,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: createCropUnit.replaceAll("__typename", ""),
        variables: {
          input: {
              farmID,
              lotID,
              name,
              plantingDate,
              cropType,
              unitType,
              quantity:
                quantity === undefined || quantity === ""
                  ? null
                  : Number(quantity),
              performedById,
              photoEvidence,
              status,
              description,
              companyID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/agro/crop-units");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <CropUnitForm onSubmit={onSubmit} initialValues={cropUnit} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Unidad de Cultivo",
    successAdded: "Unidad de Cultivo agregada con éxito",
    responses: {},
  },
});

export default CropUnitCreateForm;
